<div class="container">
    <h1 class="page-title">County Overview</h1>
    <!--section-->
    <section class="widget">
        <div class="widget-body">
            <div class="mt">
                <!--form-->
                <form class="form-horizontal" [formGroup]="form" novalidate>
                    <!--County-->
                    <div class="row form-group">
                        <div class="col-md-12 p-l-3 p-r-3">
                            <!--Name-->
                            <div class="row mx-0 form-group">
                                <span class="font-weight-bold ps-0 col-md-3 name-label">County Name</span>
                                <div class="col-md-9">
                                    <input [formControl]="countyNameControl"
                                           name="countyNameControl"
                                           class="form-control"
                                           type="text"
                                           placeholder="County Name">
                                </div>
                            </div>

                            <div class="program-type-card mt-4">
                                <div class="program-type-card-header">
                                    <span class="card-label">St. Louis Water</span>
                                </div>
                                <div class="p-3">
                                <!--STL Water Active Internal-->
                                <div class="row mx-0 form-group"
                                     [class.has-danger]="!isStlWaterActiveInternalControl?.valid && isStlWaterActiveInternalControl?.touched">
                                    <div class="display-flex flex-row w-50 align-items-center">
                                        <span class="font-weight-bold me-4 county-app-label">Enable Internal Application</span>
                                        <input type="checkbox"
                                               [formControl]="isStlWaterActiveInternalControl"
                                               name="isStlWaterActiveInternalControl"
                                        />
                                    </div>

                                </div>
                                <!--StlWater Active External-->
                                <div class="row mx-0 form-group"
                                     [class.has-danger]="!isStlWaterActiveExternalControl?.valid && isStlWaterActiveExternalControl?.touched">
                                    <div class="display-flex flex-row w-50 align-items-center">
                                    <span class="font-weight-bold county-app-label me-4">Enable Public Application</span>
                                    <input type="checkbox"
                                           [formControl]="isStlWaterActiveExternalControl"
                                           name="isStlWaterActiveExternalControl"
                                    />
                                    </div>
                                </div>
                                <div *ngIf="isStlWaterActiveExternalValue" class="form-group ps-2"
                                     [class.has-danger]="!selectedStlWaterFundAdministrativePledgeTypeControl?.valid && selectedStlWaterFundAdministrativePledgeTypeControl?.touched">
                                        <div class="display-flex flex-row align-items-center">
                                            <span class="required-label me-4 county-app-label">Managing Fund/Organization</span>
                                                <select class="drop-down-line form-select county-fund-select"
                                                        [formControl]="selectedStlWaterFundAdministrativePledgeTypeControl">
                                                    <option value="">-- Select Fund --</option>
                                                    <option *ngFor="let stlWaterFundAdministrativePledgeType of fundAdministrativePledgeTypes"
                                                            [value]="stlWaterFundAdministrativePledgeType.id">
                                                        {{ stlWaterFundAdministrativePledgeType.name }}
                                                    </option>
                                                </select>
                                        </div>
                                    <div class="row mx-0" *ngIf="selectedStlWaterFundAdministrativePledgeTypeControl?.hasError('requiredWhen') && selectedStlWaterFundAdministrativePledgeTypeControl?.touched">
                                        <span class="alert alert-danger mt-3">
                                            Managing Fund/Organization is required when enabling public application
                                        </span>
                                    </div>
                                </div>
                                </div>
                                </div>

                            <div class="program-type-card mt-3">
                                <div class="program-type-card-header">
                                    <span class="card-label">UHONS</span>
                                </div>
                                <div class="p-3">
                                    <!--STL Water Active Internal-->
                                    <div class="row mx-0 form-group"
                                         [class.has-danger]="!isUhonsActiveInternalControl?.valid && isStlWaterActiveInternalControl?.touched">
                                        <div class="display-flex flex-row w-50 align-items-center">
                                        <span class="font-weight-bold me-4 county-app-label">Enable Internal Application</span>
                                        <input type="checkbox"
                                               [formControl]="isUhonsActiveInternalControl"
                                               name="isUhonsActiveInternalControl"
                                               class="custom-checkbox"
                                        />
                                    </div>
                                    </div>
                                    <!--StlWater Active External-->
                                    <div class="row mx-0 form-group"
                                         [class.has-danger]="!isUhonsActiveExternalControl?.valid && isUhonsActiveExternalControl?.touched">
                                        <div class="display-flex flex-row w-50 align-items-center">
                                        <span class="font-weight-bold me-4 county-app-label">Enable Public Application</span>
                                        <input type="checkbox"
                                               [formControl]="isUhonsActiveExternalControl"
                                               name="isUhonsActiveExternalControl"
                                               class="custom-checkbox"
                                        />
                                    </div>
                                    </div>
                                    <div *ngIf="isUhonsActiveExternalValue" class="form-group ps-2"
                                         [class.has-danger]="!selectedUhonsFundAdministrativePledgeTypeControl?.valid && selectedUhonsFundAdministrativePledgeTypeControl?.touched">
                                            <div class="display-flex flex-row align-items-center">
                                                <span class="required-label me-4 county-app-label">Managing Fund/Organization</span>
                                                <select class="drop-down-line form-select county-fund-select"
                                                        [formControl]="selectedUhonsFundAdministrativePledgeTypeControl">
                                                    <option value="">-- Select Fund --</option>
                                                    <option *ngFor="let uhonsFundAdministrativePledgeType of fundAdministrativePledgeTypes"
                                                            [value]="uhonsFundAdministrativePledgeType.id">
                                                        {{ uhonsFundAdministrativePledgeType.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        <div class="row mx-0" *ngIf="selectedUhonsFundAdministrativePledgeTypeControl?.hasError('requiredWhen') && selectedUhonsFundAdministrativePledgeTypeControl?.touched">
                                        <span class="alert alert-danger mt-3" style="width: 100%">
                                            Managing Fund/Organization is required when enabling public application
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!--submit-->
                    <div class="row form-group">
                            <div class="display-flex flex-row align-items-center w-100 justify-content-end btn-form">
                                <!--save-->
                                <button [disabled]="!form.dirty"
                                        type="button"
                                        class="btn btn-primary me-2"
                                        (click)="onSave()"
                                >Save County
                                </button>
                                <cancel-button class="p-l-1 pull-right" [route]="'/app/counties'"></cancel-button>
                            </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</div>
